import { defineType } from "sanity";
import { multilingualStringPreview } from "../../base/multilingualArrayString";

export default defineType({
  name: "fileCTA",
  type: "object",
  title: "File CTA",
  fields: [
    {
      name: "label",
      type: "multilingualArrayString",
      description: 'leave empty for "Download"'
    },
    {
      name: "file",
      title: "File",
      type: "multilingualFile",
      validation: (Rule) => Rule.required()
    },
    {
      name: "type",
      type: "buttonType"
    }
  ],
  preview: {
    select: {
      title: "label"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || "Download"
      };
    }
  }
});
